import { type AdminJobPostingsListParams, getAdminJobPostingsListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminJobPostingsListParams };

export const jobsQuery = ({ search }: QueriesInput) => getAdminJobPostingsListQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [jobsQuery(input)];
